var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCareerState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#F0F0F0",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11124_3877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 58,
    width: 150,
    height: 134.507,
    rx: 5.6338,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.3521,
    y: 58.3521,
    width: 149.296,
    height: 133.803,
    rx: 5.28169,
    stroke: "#FAFAFA",
    strokeWidth: 0.704225
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.9296,
    cy: 83.7044,
    r: 15.8451,
    fill: "#DEDEDE",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0845,
    y: 109.406,
    width: 80.9859,
    height: 9.15493,
    rx: 4.57746,
    fill: "#DEDEDE",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0845,
    y: 124.898,
    width: 121.831,
    height: 6.33803,
    rx: 3.16901,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0845,
    y: 153.773,
    width: 45.0704,
    height: 4.92958,
    rx: 2.46479,
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11124_3877",
    x: 41.5493,
    y: 53.7746,
    width: 166.901,
    height: 151.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.22535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.22535
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.532 0 0 0 0 0.5476 0 0 0 0 0.568 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11124_3877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11124_3877",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCareerState);
export default __webpack_public_path__ + "static/media/empty-career-state.9a6fc5068ee749d70865520c8e98f164.svg";
export { ForwardRef as ReactComponent };